import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function About() {
  return (
    <>
      <div id="rapid-about-us" className="page"></div>
      <Header />

      <section
        style={{ scrollMarginTop: "80px" }}
        className="bg-light py-5 border border-3 my-shadow "
      >
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Image */}
            <div className="col-lg-6 text-center">
              <img
                className="img-fluid rounded shadow"
                src="images/assets/rapid-Lab-staff.png"
                alt="Rapid Lab Diagnostics Team"
              />
            </div>

            {/* About Content */}
            <div className="col-lg-6 text-primary-emphasis">
              <h2 className="mb-3">About Rapid Lab & Diagnostics</h2>

              <p className="fw-semibold text-dark">
                Rapid Lab & Diagnostics is a leading modern diagnostic center
                based in Tema, committed to delivering accurate, timely, and
                reliable medical testing services. We understand that every
                diagnosis matters, which is why we combine advanced technology
                with expert knowledge to ensure precision in every result.
              </p>

              <p className="fw-semibold text-Primary-emphasis">
                Our facility is equipped with state-of-the-art diagnostic
                equipment capable of handling both routine and complex tests
                efficiently. From laboratory services to imaging solutions, we
                provide a full range of diagnostics tailored to meet the needs
                of patients, clinics, and healthcare providers.
              </p>

              <p className="fw-semibold  text-Primary-emphasis">
                At Rapid Lab & Diagnostics, patient care is our top priority.
                Our team of highly trained professionals ensures a smooth,
                respectful, and stress-free experience for every patient. We
                also offer secure online access to test results, allowing for
                quick and convenient healthcare decisions.
              </p>

              {/* Mission & Vision */}
              <h4 className="mt-4">Our Mission</h4>
              <p className="fw-semibold  text-Primary-emphasis">
                To provide fast, accurate, and reliable diagnostic services that
                empower better healthcare decisions.
              </p>

              <h4 className="mt-3">Our Vision</h4>
              <p className="fw-semibold text-Primary-emphasis">
                To become the most trusted diagnostic center in Greater Accra
                and beyond, known for excellence, innovation, and compassionate
                care.
              </p>

              {/* Why Choose Us */}
              <h4 className="mt-4">Why Choose Us?</h4>
              <ul className="text-primary-emphasis fw-semibold">
                <li className="list-unstyled">
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Advanced diagnostic technology
                </li>
                <li className="list-unstyled">
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Fast turnaround time
                </li>
                <li className="list-unstyled">
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Experienced and professional staff
                </li>
                <li className="list-unstyled">
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Secure online test results
                </li>
                <li className="list-unstyled">
                  <span>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Affordable and patient-focused care
                </li>
                <li className="list-unstyled">
                  <span>
                    {"   "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="#ffc107"
                      className="bi bi-check-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>{" "}
                  </span>
                  Strict quality control systems
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CAREERS SECTION ================= */}
      <section
        id="careers"
        style={{ scrollMarginTop: "80px" }}
        className="py-5 bg-white border-top"
      >
        <div className="container text-center">
          <h2 className="text-primary-emphasis mb-3 ">Careers at Rapid Lab</h2>

          <p className="text-primary-emphasis fw-semibold col-lg-8 mx-auto ">
            At Rapid Lab & Diagnostics, we are always looking for passionate,
            dedicated, and talented individuals to join our team. Whether you
            are experienced or just starting your career, we provide an
            environment that encourages growth, learning, and excellence in
            healthcare service delivery.
          </p>

          <p className="text-primary-emphasis fw-semibold col-lg-8 mx-auto">
            We believe in teamwork, innovation, and putting patients first. If
            you are committed to making a difference and contributing to quality
            healthcare, we would love to hear from you.
          </p>

          {/* Why Work With Us */}
          <div className="mt-4">
            <h4 className="text-primary-emphasis ">Why Work With Us?</h4>
            <ul className="list-unstyled text-dark fw-semibold text-primary-emphasis">
              <li>✔ Supportive and professional work environment</li>
              <li>✔ Opportunities for growth and development</li>
              <li>✔ Access to modern medical technology</li>
              <li>✔ A culture built on integrity and teamwork</li>
              <li>✔ The chance to make a real impact in healthcare</li>
            </ul>
          </div>

          {/* CTA */}
          <div className="mt-4">
            <h5 className="text-primary-emphasis">Interested in Joining Us?</h5>
            <p className="text-muted">Send your CV and application to:</p>
            <Link
              to="mailto:rapidlabdiagnostics@yahoo.com"
              className="btn btn-primary px-4"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default About;
